module.exports = __webpack_public_path__ + "static/media/18ECA12.d6401503.jpg";